export const addCustomCssRule = (selector, styleStr, desktopMediaquery, minAncho) => {
  let css = '';
  let minWidth = 768;

  if (minAncho && parseInt(minAncho, 10) !== Number.isNaN()) {
    minWidth = parseInt(minAncho, 10);
  }

  if (desktopMediaquery) {
    css += `@media (min-width :${minWidth}px){`;
    css += `${selector} {${styleStr}}`;
    css += '}';
  } else {
    css += `${selector} {${styleStr}}`;
  }

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.scssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
}

export const addMediaQuery = (selector, styleStr, kind = 'nodevice') => {
  let css = '';
  // 1) deciding media query
  switch (kind) {
    case 'pc': css = `${css}@media screen and (min-width: 1260px){`; break;
    case 'mobile': css = `${css}@media screen and (min-width: 0px) and (max-width: 768px) {`; break;
    case 'mobileWhenNoTablet': css = `${css}@media screen and (min-width: 0px) and (max-width: 1260px) {`; break;
    case 'nodevice': css = ''; break;
    case 'tablet':
    default: css = `${css}@media screen and (min-width: 768px) and (max-width: 1260px) {`; break;
  }
  // appending instructions
  css += `${selector} {${styleStr}}${kind === 'nodevice' ? '{' : ''}`;
  css += '}';

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
}

/* it depends on full or container width */
/* it is important, know how pictures we have */
export const bannerBuildBGImg = (currentBGImg, idBanner, div2Fit, bgColor) => {
  /* Adding css rules for background image media queries */
  if (div2Fit === 'container') {
    div2Fit = ' .container';
  } else {
    // carga a full es placebo
    div2Fit = '';
  }
  const node2AplyBG = `${idBanner}${div2Fit}`

  /* BACKGROUNDS AND SHADES LIMIT */
  if (currentBGImg && currentBGImg.picMobile) {
    const deviceToAttach = !currentBGImg.picTablet ? 'mobileWhenNoTablet' : 'mobile';
    const { picMobile } = currentBGImg;
    const {
      position,
      size,
      src,
      shadeLimit,
    } = picMobile;
    // esta imagen al ser en movil si el div2Fit es container ni mijita tiene que ser a full
    const node2AplyBGOnMobile = `${idBanner}`;
    addMediaQuery(
      `#${node2AplyBGOnMobile}`,
      `background-image: url(${src});
       background-size: ${size};
       background-position: ${position};`,
      deviceToAttach,
    )

    if (!shadeLimit) {
      addMediaQuery(
        `#${idBanner} .banner_shade_left,
         #${idBanner} .banner_shade_right`,
        'display: none',
        deviceToAttach,
      )
    }
  }

  if (currentBGImg && currentBGImg.picTablet) {
    const { picTablet } = currentBGImg;
    const {
      position,
      size,
      src,
      shadeLimit,
    } = picTablet;
    addMediaQuery(
      `#${node2AplyBG}`,
      `background-image: url(${src});
       background-size: ${size};
       background-position: ${position};`,
      'tablet',
    );

    addMediaQuery(
      `#${idBanner} .banner_shade_left,
       #${idBanner} .banner_shade_right`,
      `display: ${shadeLimit ? 'block' : 'none'}`,
      'tablet',
    )
  }

  if (currentBGImg && currentBGImg.picDesktop) {
    const { picDesktop } = currentBGImg;
    const {
      position,
      size,
      src,
      shadeLimit,
    } = picDesktop;

    addMediaQuery(
      `#${node2AplyBG}`,
      `background-image: url(${src});
       background-size: ${size};
       background-position: ${position};`,
      'pc',
    );

    addMediaQuery(
      `#${idBanner} .banner_shade_left,
       #${idBanner} .banner_shade_right`,
      `display: ${shadeLimit ? 'block' : 'none'}`,
      'pc',
    )
  }

  /* SET DEFAULT BACKGROUND */
  if (bgColor) {
    addMediaQuery(
      `#${idBanner}`,
      `background-color: ${bgColor}`,
      'no',
    );
  }
}


export const whichAnimationEvent = () => {
  const el = document.createElement('fakeelement');
  const transitions = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
  }

  let transition = null;

  Object.keys(transitions).forEach((t) => {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
}


export const whichTransitionEvent = () => {
  const el = document.createElement('fakeelement');
  const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  }

  let transition = null;

  Object.keys(transitions).forEach((t) => {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
}